import React from "react";
import Layout from "../components/Layout";
import SEOHead from "../components/SEOHead";
import PageHeader from "../components/PageHeader";
import { IconGovernment, IconCompliance, IconBudget, IconInfrastructure, IconCyber, IconAI, IconDataMonitor, IconWater } from "../brand/icons";

const PILLARS = [
  { I: IconGovernment,    t: "Civic Authority",          d: "AuditIQ integrates with municipal ERP/finance exports with non-intrusive read-only feeds." },
  { I: IconCompliance,    t: "Public Records Compliance",d: "Respects robots.txt, public-pages-only access, and FOIA-friendly outputs." },
  { I: IconBudget,        t: "Budget Surface",           d: "Adopted budgets, CIPs, procurement summaries, and department line items." },
  { I: IconInfrastructure,t: "Infrastructure Index",     d: "Roads, drainage, water, wastewater, stormwater, parks, resilience." },
  { I: IconCyber,         t: "Cybersecurity Sync",       d: "Policy sync between AuditIQ governance and CyberWater operational defense." },
  { I: IconAI,            t: "AI Recommendations",       d: "Preliminary reallocation analysis with non-accusatory framing." },
  { I: IconDataMonitor,   t: "Executive Dashboards",     d: "Navy + gold + cream panels fit for council chamber briefings." },
  { I: IconWater,         t: "Water Defense Layer",      d: "Sensor integrity, PLC command validation, and multi-party control." },
];

const GovernmentEight = () => (
  <Layout>
    <SEOHead title="Government Eight Integration | AuditIQ" path="/government-eight"
      description="AuditIQ Government Eight integration — the eight pillars connecting municipal governance to AI-powered accountability and cybersecurity." />
    <PageHeader eyebrow="Integration" title="Government Eight."
      subtitle="Eight integration pillars that connect municipal governance to AI-powered transparency and defensive cybersecurity — one coordinated accountability platform." />
    <section className="max-w-[1400px] mx-auto px-6 py-16 grid md:grid-cols-2 lg:grid-cols-4 gap-5">
      {PILLARS.map(({ I, t, d }, idx) => (
        <div key={t} className="panel-elev p-6">
          <div className="flex items-center justify-between">
            <I size={28} />
            <span className="text-[10px] uppercase tracking-[0.26em] text-steel">{String(idx+1).padStart(2, "0")}</span>
          </div>
          <div className="font-display text-lg mt-4">{t}</div>
          <div className="text-sm text-cream-dim mt-2">{d}</div>
        </div>
      ))}
    </section>
  </Layout>
);

export default GovernmentEight;
